import { render, staticRenderFns } from "./LLCheckboxList.vue?vue&type=template&id=39962853&scoped=true"
import script from "./LLCheckboxList.vue?vue&type=script&lang=js"
export * from "./LLCheckboxList.vue?vue&type=script&lang=js"
import style0 from "./LLCheckboxList.vue?vue&type=style&index=0&id=39962853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39962853",
  null
  
)

export default component.exports